<template>
  <div>

   <v-overlay v-if="showLoading" color="#f1f1f1">
      <v-layout justify-center align-center>
        <v-progress-circular
          :size="64"
          indeterminate
          color="primary">
        </v-progress-circular>
      </v-layout>
    </v-overlay> 

  </div>
</template>

<script>

  export default {
    name: 'LoadingOverlay',
    props: {
        show: { type: Boolean },
    },
    data() {
      return {
        
      };
    },
    computed: {
      showLoading: {
        get() { return this.show; },
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>